'use strict';

/* jshint ignore:start */
/**
 * This code was generated by
 * \ / _    _  _|   _  _
 *  | (_)\/(_)(_|\/| |(/_  v1.0.0
 *       /       /
 */
/* jshint ignore:end */

var _ = require('lodash');  /* jshint ignore:line */
var TrunkList = require('./v1/trunk').TrunkList;
var Version = require('../../base/Version');  /* jshint ignore:line */


/* jshint ignore:start */
/**
 * Initialize the V1 version of Trunking
 *
 * @constructor Twilio.Trunking.V1
 *
 * @property {Twilio.Trunking.V1.TrunkList} trunks - trunks resource
 *
 * @param {Twilio.Trunking} domain - The twilio domain
 */
/* jshint ignore:end */
function V1(domain) {
  Version.prototype.constructor.call(this, domain, 'v1');

  // Resources
  this._trunks = undefined;
}

_.extend(V1.prototype, Version.prototype);
V1.prototype.constructor = V1;

Object.defineProperty(V1.prototype,
  'trunks', {
    get: function() {
      this._trunks = this._trunks || new TrunkList(this);
      return this._trunks;
    }
});

module.exports = V1;
